import React, { useContext } from 'react'
import './css/Shopcategory.css'
import { ShopContext } from '../Context/ShopContext'
import Item from '../Components/Item/Item'

const ShopCategory = (props) => {
  const {all_product} = useContext(ShopContext)
  return (
    <div className='shop-category' >
      <div className="all-product">
        {all_product.map((item,i)=>{
          if(props.category===item.category){
              return <Item key={i} id={item.id} name={item.name} image={item.image} desc={item.desc} sideimg={item.sideimg} price={item.price} />
          }else{
            return null
          }
        })}
      </div>
    </div>
  )
}

export default ShopCategory